import { Row, Col } from 'antd'
import Title from '@common/Title'
import ResponsiveTableCard from '@common/ResponsiveTableCard'
import { columns } from '@components/Order/Table'
import OrderDrawer from '@components/Order/OrderDrawer'
import { ActionsItems } from '@components/Order/Actions'
import { useTranslation } from 'react-i18next'
import OrderFilters from '@components/Order/OrderFilters'
import Icon from '@components/common/Icon'
import { useTheme } from 'styled-components'
import { useEffect } from 'react'
import { useUser } from '@contexts/UserContext'

const Orders = () => {
  const numForm = Math.floor(Math.random() * 10000).toString()
  const { t } = useTranslation()
  const theme = useTheme()
  const { perPage, setPerPage } = useUser()

  useEffect(() => {
    const originalPerPage = perPage
    setPerPage(20)

    return () => {
      setPerPage(originalPerPage)
    }
  }, [])

  return (
    <Row gutter={[16, 8]}>
      <Col xl={12} xs={24}>
        <Title name={t('QUOTES')} />
      </Col>
      <Col span={24}>
        <ResponsiveTableCard
          style={{ width: '100%' }}
          {...{ columns, url: '/order?sort=-created_at' }}
        >
          <OrderFilters />
          <Row>
            <Col xl={{ span: 2, offset: 18 }} xs={24}>
              <OrderDrawer action={'create'} numForm={numForm}>
                <ActionsItems action='create' icon={<Icon name="fa-regular fa-file-plus" color="white" />}
                  style={{ backgroundColor: theme.green, color: theme.white }}
                />
              </OrderDrawer>
            </Col>
            <Col xl={{ span: 2, offset: 1 }} xs={24}>
              <OrderDrawer action={'change'} numForm={numForm}>
                <ActionsItems action='change'
                  icon={<Icon name="fas fa-arrow-up" color="white" />}
                  style={{ backgroundColor: theme.blue, color: theme.white }}
                />
              </OrderDrawer>
            </Col>
          </Row>
        </ResponsiveTableCard>
      </Col>
    </Row>
  )
}

export default Orders
